import ProgrammeCard from "./ProgrammeCard";

export default ProgrammeCard;
